import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class AddGroupErrorAction implements Action {
  public static readonly type = 'AddGroupErrorAction';

  constructor(public error: BijbError) {
  }

  public type = AddGroupErrorAction.type;
}
